import {CdEpSkipReason} from '../../../interfaces/care/cd-execution-proof/cd-ep-skip-reason';

export class CdEpSkipReasonFactory {

  public static fromObject(cdEpSkipReason: any): CdEpSkipReason {
    return new class implements CdEpSkipReason {
      id: number = cdEpSkipReason.id;
      name: string = cdEpSkipReason.name;
      shortName: string = cdEpSkipReason.short_name;
      withOwnReason: boolean = cdEpSkipReason.with_own_reason;
      isDefault: boolean = cdEpSkipReason.is_default;
      sort: number = cdEpSkipReason.sort;
      isActive: boolean = cdEpSkipReason.is_active;
    };
  }

  public static fromArray(cdEpSkipReasons: any[]): CdEpSkipReason[] {
    return cdEpSkipReasons.map(cdEpSkipReason => this.fromObject(cdEpSkipReason));
  }

}
